import { NormalizationUtilities } from "../storeTypes";
import { themeNormalization } from "../themes/normalization";
import { PlayerState } from "../rootReducer";
import {
  getEmptyTraversalObject,
  mergeTraversalResult,
} from "../normalizationUtils";
import { orgSchema } from "../normalizationSchemas";
import { NormalizedOrgFragment } from "./types";

export const orgNormalization: NormalizationUtilities = {
  schema: orgSchema,
  traverseFunction: (orgId: string, state: PlayerState) => {
    let result = getEmptyTraversalObject();

    if (state.organization.defaultThemeId) {
      result = mergeTraversalResult(
        result,
        themeNormalization.traverseFunction(
          state.organization.defaultThemeId,
          state
        )
      );
    }

    return result;
  },
};

export type NormalizedOrgEntities = {
  orgs: { [key: string]: NormalizedOrgFragment } | null;
};
